import { render } from "./Details.vue?vue&type=template&id=17d6cc93&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=17d6cc93&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d6cc93"]])

export default __exports__